module.exports = __webpack_public_path__ + "static/undraw_work_chat_erdt-09cdc56d2892492fb034a5c7b0b0532f.svg";